import QueryProvider from './QueryProvider';
import { AuthProvider } from '../../auth';
import { ShellProvider } from '../../layouts/ShellContext';

/**
 * Composes all app-level providers.
 *
 * Order matters:
 * 1. QueryProvider - API caching layer
 * 2. AuthProvider - User authentication state
 * 3. ShellProvider - Per-page top-bar slot registration (Tank Redesign)
 */
export default function AppProviders({ children }) {
  return (
    <QueryProvider>
      <AuthProvider>
        <ShellProvider>{children}</ShellProvider>
      </AuthProvider>
    </QueryProvider>
  );
}
